var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"k_chart2"}}),_c('div',{staticClass:"k_time"},[_c('span',[_vm._v(_vm._s(_vm.t1))]),_c('span',[_vm._v(_vm._s(_vm.t2))])]),_c('div',{attrs:{"id":"k_chart3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }